import React, { Component } from 'react'
import SchoolYearsPV from './SchoolYearsPV'
import AuthA from '../../store/actions/AuthA'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import {connect} from 'react-redux'

const _ = {
    sortBy: sortBy
}

class SchoolYearPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: '',
      fields: ['name', 'code', 'startDate', 'endDate', 'actions'],
      activePage: 1,
      itemPerPage: 10,
      selectedIndex: 0,
      column: null,
      direction: null,
      loaded: false
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.getSchoolYear = this.getSchoolYear.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  getSchoolYear() {
    axios.get(process.env.REACT_APP_URL+'/schoolYears?filter[where][active]=true')
    .then(response => {
      this.setState({ data: response.data, loaded: true });
    });
  }

  isSearched(searchKey) {
    return function(item) {
      return (
        !searchKey ||
        item.name.toLowerCase().includes(searchKey.toLowerCase()) ||
        item.code.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handlePaginationChange(e, {activePage}){
    this.setState({
      activePage: activePage,
    });
  }

  handleRowClick(schoolYear) {
    this.props.history.push(this.props.location.pathname+'/' + schoolYear.schoolYearId);
  }

  handleSubmit(data) {
    const url = process.env.REACT_APP_URL+'/schoolYears';
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {this.getSchoolYear()})
      .catch(err => console.log(err));
  }

  handleUpdate(data,id) {
    const url = process.env.REACT_APP_URL+'/schoolYears/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {this.getSchoolYear()})
      .catch(err => console.log(err));
  }

  handleDelete(id) {
    const url = process.env.REACT_APP_URL+'/schoolYears/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false}
      })
      .then(response => {this.getSchoolYear()})
      .catch(err => console.log(err));
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup / School Year'});
    this.getSchoolYear();
  }

  render() {
    return (
      <SchoolYearsPV
        auth={this.props.auth}
        userType={this.props.userType}
        activePage={this.state.activePage}
        itemPerPage={this.state.itemPerPage}
        column={this.state.column}
        direction={this.state.direction}
        data={this.state.data}
        searchKey={this.state.searchKey}
        fields={this.state.fields}
        loaded={this.state.loaded}
        isSearched={this.isSearched}
        onSearchChange={this.onSearchChange}
        handleSort={this.handleSort}
        handlePaginationChange={this.handlePaginationChange}
        handleRowClick={this.handleRowClick}
        handleSubmit={this.handleSubmit}
        handleUpdate={this.handleUpdate}
        handleDelete={this.handleDelete}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SchoolYearPC);
